export default {
  NODE_ENV: process.env.NODE_ENV,
  BASE_URL: process.env.BASE_URL,
  ROOT_URL: process.env.REACT_APP_ROOT_URL,
  API_URL: process.env.REACT_APP_API_URL,
}
